import { j as l } from "./jsx-runtime-3tyXYecC.mjs";
import { f as t } from "./index-LyFokDcn.mjs";
import { m as j } from "./tss-DN0acMKN.mjs";
import { M as F, d as S } from "./constants-CnFYFetN.mjs";
import { g as r } from "./get-encore-value-Di648HqV.mjs";
import { I as z } from "./icon-v2-DGtVEk7e.mjs";
import { L as v } from "./link-0A1muLDU.mjs";
const k = {
  "extra-small": "h5",
  small: "h4",
  medium: "h3",
  large: "h2",
  "extra-large": "h1"
}, w = j()((x, u, h) => {
  const { constructs: f, mode: d, palette: i, spacing: o, typography: e } = x, { color: c, justify: n, shouldFlex: p, size: a, url: y } = u, s = r(c, {
    primary: t.ifFeature("encore", f.text.primary.strong, i.primary.main),
    "neutral-weak": t.ifFeature("encore", f.text.neutral.weak, i.grey[700]),
    "neutral-medium": t.ifFeature("encore", f.text.neutral.strong, i.grey[800]),
    "neutral-strong": t.ifFeature("encore", f.text.neutral.xStrong, i.grey[1e3]),
    "neutral-inverted": t.ifFeature("encore", f.text.neutral.inverted, i.common.white)
  }), m = r(a, {
    "extra-small": e.h5.lineHeight,
    small: e.h4.lineHeight,
    medium: e.h3.lineHeight,
    large: e.h2.lineHeight,
    "extra-large": e.h1.lineHeight
  }), g = r(a, {
    "extra-small": o(1.5),
    small: o(1.5),
    medium: o(1.5),
    large: o(2),
    "extra-large": o(2.5)
  }), W = {
    center: "center",
    end: "right",
    start: "left"
  };
  return {
    icon: {
      alignItems: "center",
      display: "inline-flex",
      fill: t.ifFeature("encore", void 0, y ? i.info.main : s),
      flexShrink: 0,
      height: m,
      marginRight: t.ifFeature("encore", g, o(1))
    },
    root: t.ifFeature(
      "encore",
      {
        ...p ? {
          alignItems: "flex-start",
          display: "flex",
          justifyContent: n
        } : {},
        color: s,
        fill: s,
        fontSize: r(a, {
          "extra-small": e.h5.fontSize,
          small: e.h4.fontSize,
          medium: e.h3.fontSize,
          large: e.h2.fontSize,
          "extra-large": e.h1.fontSize
        }),
        fontWeight: r(a, {
          "extra-small": e.h5.fontWeight,
          small: e.h4.fontWeight,
          medium: e.h3.fontWeight,
          large: e.h2.fontWeight,
          "extra-large": e.h1.fontWeight
        }),
        fontFamily: r(a, {
          "extra-small": e.h5.fontFamily,
          small: e.h4.fontFamily,
          medium: e.h3.fontFamily,
          large: e.h2.fontFamily,
          "extra-large": e.h1.fontFamily
        }),
        lineHeight: m,
        margin: 0,
        outline: d === F.Dye ? `1px solid ${S.main}` : void 0,
        overflowWrap: "anywhere",
        padding: 0,
        textAlign: n && W[n],
        wordBreak: "normal"
      },
      {
        alignItems: "center",
        display: "flex",
        color: s,
        fill: s,
        fontSize: r(a, {
          "extra-small": e.h5.fontSize,
          small: e.h4.fontSize,
          medium: e.h3.fontSize,
          large: e.h2.fontSize,
          "extra-large": e.h1.fontSize
        }),
        fontWeight: r(a, {
          "extra-small": e.h5.fontWeight,
          small: e.h4.fontWeight,
          medium: e.h3.fontWeight,
          large: e.h2.fontWeight,
          "extra-large": e.h1.fontWeight
        }),
        fontFamily: r(a, {
          "extra-small": e.h5.fontFamily,
          small: e.h4.fontFamily,
          medium: e.h3.fontFamily,
          large: e.h2.fontFamily,
          "extra-large": e.h1.fontFamily
        }),
        justifyContent: n,
        lineHeight: m,
        margin: 0,
        outline: d === F.Dye ? `1px solid ${S.main}` : void 0,
        overflowWrap: "anywhere",
        padding: 0,
        wordBreak: "normal"
      }
    ),
    link: {
      alignItems: t.ifFeature("encore", "flex-start", "center"),
      color: t.ifFeature("encore", void 0, i.info.main),
      display: "inline-flex",
      fill: t.ifFeature("encore", void 0, i.info.main),
      fontWeight: e.fontWeightSemibold,
      textDecoration: t.ifFeature("encore", "inherit"),
      ...t.ifFeature(
        "encore",
        {},
        {
          [`&:hover .${h.icon}, &:focus-visible .${h.icon}`]: t.ifFeature("encore", void 0, {
            fill: i.primary.main
          })
        }
      )
    }
  };
});
function $(x) {
  const { ariaLabel: u, children: h, color: f = "primary", component: d, icon: i, id: o, justify: e, size: c, url: n, classes: p, ...a } = x, y = d ?? k[c], s = !!(e || i), { classes: m } = w({ color: f, justify: e, shouldFlex: s, size: c, url: n }, { props: { classes: p } }), g = /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    i && /* @__PURE__ */ l.jsx("span", { className: m.icon, children: t.ifFeature(
      "encore",
      typeof i == "string" ? /* @__PURE__ */ l.jsx(
        z,
        {
          name: i,
          size: r(c, {
            "extra-small": 20,
            small: 20,
            medium: 24,
            large: 32,
            "extra-large": 48
          })
        }
      ) : null,
      i
    ) }),
    t.ifFeature("encore", s ? /* @__PURE__ */ l.jsx("span", { children: h }) : h, h)
  ] });
  return /* @__PURE__ */ l.jsx(y, { className: m.root, "data-fabric-component": a["data-fabric-component"], id: o, children: n ? t.ifFeature(
    "encore",
    /* @__PURE__ */ l.jsx(v, { ariaLabel: u, href: n, children: /* @__PURE__ */ l.jsx("span", { className: m.link, children: g }) }),
    /* @__PURE__ */ l.jsx("a", { "aria-label": u, className: m.link, href: n, children: g })
  ) : g });
}
export {
  $ as B
};
//# sourceMappingURL=base-headline-Dw8BrcrM.mjs.map
